import { useSelector } from 'react-redux';
import { LogOut } from 'react-feather';
import logo from '../assets/Best_National_Carports-logo-blk.svg';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../slices/userSlice';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import user_placeholder from '../assets/user_placeholder.png';
import jwService from '../services/jwService';

function Header() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const handleSignOut = () => {
		dispatch(logoutUser());
		jwService.cleanToken();
		if (location.pathname !== '/') {
			localStorage.setItem('lastVisitedPage', location.pathname);
			// cookieService.deleteCookie('_bnc');
		}
		navigate('/');
	};

	const selftAccount = useSelector((state) => state?.auth?.self);

	return (
		<div className="header p-5 bg-secondColor-100">
			<div className="flex flex-wrap items-center justify-between gap-3">
				<div className="flex items-center">
					<Link to={'/'}>
						<div className="w-32 sm:w-40">
							<img src={logo} alt="Best National Carports Logo" />
						</div>
					</Link>
				</div>
				<div className="top-left-nav flex flex-wrap items-center gap-3">
					<div className="up-left">
						<p>Hi</p>
						<Link to={'/profile'} className="name_pic">
							{selftAccount?.profilePicture ? (
								<div className="profilePict">
									<img src={selftAccount?.profilePicture} alt="profile" />
								</div>
							) : (
								<div className="profilePict">
									<img src={user_placeholder} alt="profile" />
								</div>
							)}{' '}
							<p>{selftAccount?.firstName}</p>
						</Link>{' '}
					</div>
					<div
						className="w-10 h-10 bg-gray-200 rounded-full flex justify-center items-center font-medium hover:cursor-pointer"
						onClick={handleSignOut}
					>
						<LogOut size={24} onClick={handleSignOut} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Header;
